import { render, staticRenderFns } from "./VehiclePage.vue?vue&type=template&id=2d027280&"
import script from "./VehiclePage.vue?vue&type=script&lang=ts&"
export * from "./VehiclePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports